<template>
  <div style="min-width: 240px;">
    <offer-status class="display_block" :payload="offer"></offer-status>
    <div class="mt-4">
      <Message
        :payload="offer"
        :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }"
      />
    </div>
    <div class="is-flex mt-4">
      <button class="button is-info is-outlined mr-4" @click="clickedCV">CV</button>
      <button class="button is-warning is-outlined mr-4" @click="aiEvaluate" title="הערכת AI">AI</button>
      <img @click="rejectOffer" src="/black_x.png" width="40" alt="reject offer icon" class="operation_icon" />
    </div>
  </div>
</template>
<script>
import OfferStatus from '@/components/OfferStatus'
import Message from '@/components/Message'
import { mapMutations } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'

export default {
  name: 'position-offers-report',
  components: {
    OfferStatus,
    Message
  },
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      offers_helper: new OffersHelper(),
      offer: {}
    }
  },
  created () {
    this.$network_utils
      .getOfferBy({
        applicant_id: this.payload.resources.applicant.resource_id,
        position_id: this.payload.resources.position.id
      })
      .then(response => {
        this.offer = response[0]
      })
  },
  methods: {
    aiEvaluate () {
      this.create({
        designator: 'ai-evaluation-modal-' + this.offer.id,
        component_name: 'AiEvaluationModal',
        data: this.offer,
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },
    clickedCV () {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data: this.offer,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    rejectOffer () {
      this.offers_helper.rejectOffer(this.offer)
    },
    ...mapMutations('modals', ['create', 'removeModalById'])
  }
}
</script>
